// extracted by mini-css-extract-plugin
module.exports = {"overviewContent":"Overview_overviewContent__2KxgP"};